import React, { Component } from "react";
import Carousel from 'react-bootstrap/Carousel';
export default class Home extends Component {
  render() {
    return (
      <div id="hdimg"  className="container text-success" >
        <Carousel data-bs-theme="dark">
          <Carousel.Item >
            <img  height={200}
              className="d-block w-100 figure-img img-fluid rounded"
              src="/a.jpeg"
              alt="First slide"
            />
            <Carousel.Caption>
              <h5>早春芽茶</h5>
              <p>清香，鲜爽，回甘，持久</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item >
            <img  
              className="d-block w-100 "
              src="/b.jpeg?height=200"
              alt="Second slide"
            />
            <Carousel.Caption>
              <h5>精选早春嫩芽，手工炒制</h5>
              <p>持续生津，唇齿留香</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item >
            <img  
              className="d-block w-100 "
              src="/c.jpeg"
              alt="Third slide"
            />
            <Carousel.Caption>
              <h5>高山原料</h5>
              <p>
                采用一芽一叶春芽，明前早春芽头
              </p>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
        </div>
    );
  }
}